const shouldRefreshBeacons = ({ sponsoredProductIds, isSorted }) =>
  !!sponsoredProductIds && !isSorted;

export default shouldRefreshBeacons;
